import { render, staticRenderFns } from "./AvisoRenovacion.vue?vue&type=template&id=23ceff12&scoped=true&"
import script from "./AvisoRenovacion.vue?vue&type=script&lang=js&"
export * from "./AvisoRenovacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ceff12",
  null
  
)

export default component.exports